<template>
  <div>
    <div class="top-area">
      <div class="container">
        <div class="row justify-content-between">
          <div class="col-sm-6">
            <div class="photo" :style="{backgroundImage:`url(${user.data.photoURL})`}"></div>
          </div>
          <div class="col-sm-6 detail">
            <h3>
              {{ user.data.displayName }}
              <span>{{ user.data.email }}</span>
            </h3>
            <button class="btn btn-small btn-outline-info" @click="openModel()">
              編輯個人檔案
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="content">
      <div class="container">
        <div class="row">
          <div class="col-md-3">
            <div class="person-data">
              <ul>
                <li>
                  <p>性別</p>
                  {{ user.data.gender }}
                </li>
                <li>
                  <p>自我簡介</p>
                  {{ user.data.bio }}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade edit-modal" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">編輯個人檔案</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-sm-6">
                <div class="form-group">
                  <label for="displayName">暱稱</label>
                  <input type="text" id="displayName" placeholder="您的暱稱" class="form-control mt-1"
                  v-model="temp.userEdit.displayName">
                </div>
              </div>
              <div class="col-sm-6">
                <div class="form-group">
                  <label for="gender">性別</label>
                  <select id="gender" class="form-control mt-1" v-model="temp.userEdit.gender">
                    <option value="男性">男性</option>
                    <option value="女性">女性</option>
                  </select>
                </div>
              </div>
              <div class="col-sm-12">
                <div class="form-group">
                  <label for="bio">自我簡介</label>
                  <textarea id="bio" rows="5" class="form-control mt-1"
                  v-model="temp.userEdit.bio"></textarea>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">取消</button>
            <button type="button" class="btn btn-primary" @click="editData()">儲存</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from 'firebase/app';
import $ from 'jquery';

export default {
  props: ['user'],
  data() {
    return {
      temp: {
        userEdit: {},
      },
    };
  },
  methods: {
    openModel() {
      const vm = this;
      this.temp.userEdit = Object.assign({}, vm.user.data);
      $('.edit-modal').modal('show');
    },
    editData() {
      const vm = this;
      firebase.database().ref(`users/${vm.user.id}`).set({
        email: vm.temp.userEdit.email,
        displayName: vm.temp.userEdit.displayName,
        photoURL: vm.temp.userEdit.photoURL,
        gender: vm.temp.userEdit.gender,
        bio: vm.temp.userEdit.bio,
      });
      $('.edit-modal').modal('hide');
    },
  },
  created() {
    // this.LoginOrNot()
  },
};
</script>

<style lang="scss" scoped>
  .top-area{
    padding: 50px 0;
    background-color: #f6f6f6;
    .photo{
      background-size: cover;
      box-sizing: content-box;
      width: 150px;
      height: 150px;
      border-radius: 50%;
      border: 5px solid #ddd;
      margin-right: 20px;
    }
    .detail{
      display: flex;
      justify-content: space-between;
      flex-direction: column;
      align-items: flex-end;
      h3{
        font-size: 24px;
        text-align: right;
        span{
          display: block;
          margin-top: 10px;
          font-size: 16px;
        }
      }
    }
  }
</style>
